import { PaddingTypes, SpacingTypes } from "../types";
import { isBrightColor } from "./color";
import { CollectionFormTypes } from "./schema";

export const paddingConfig = {
  [PaddingTypes.NORMAL]:
    "testify-px-4 testify-py-3 md:testify-px-6 md:testify-py-5 lg:testify-px-8 lg:testify-py-6",
  [PaddingTypes.COMPACT]:
    "testify-px-2 testify-py-2 md:testify-px-3 md:testify-py-3 lg:testify-px-4 lg:testify-py-4",
  [PaddingTypes.RELAXED]:
    "testify-px-6 testify-py-5 md:testify-px-8 md:testify-py-7 lg:testify-px-12 lg:testify-py-10",
  [PaddingTypes.SPACIOUS]:
    "testify-px-8 testify-py-6 md:testify-px-12 md:testify-py-10 lg:testify-px-16 lg:testify-py-14",
};

export const spacingConfig = {
  [SpacingTypes.TIGHT]:
    "testify-space-y-1 md:testify-space-y-1.5 lg:testify-space-y-2",
  [SpacingTypes.NORMAL]:
    "testify-space-y-2 md:testify-space-y-3 lg:testify-space-y-4",
  [SpacingTypes.RELAXED]:
    "testify-space-y-3 md:testify-space-y-4 lg:testify-space-y-6",
};

export const getCollectionFormStyles = (data: CollectionFormTypes) => {
  return {
    background: data.branding.style.backgroundColor.includes("https")
      ? `url(${data.branding.style.backgroundColor})`
      : data.branding.style.backgroundColor,
    fontFamily: `${data.branding.style.font}, sans-serif`,
    textColor: data.branding.style.textColor,
    font: `https://fonts.googleapis.com/css?family=${data.branding.style.font}`,
    primaryColor: data.branding.style.primaryColor,
    secondaryColor: data.branding.style.secondaryColor,
    secondaryTextColor: isBrightColor(
      data.branding.style.secondaryColor || data.branding.style.textColor || "",
    )
      ? "black"
      : "white",
    cardPadding: paddingConfig[data.branding.style.containerPadding],
    cardSpacing: spacingConfig[data.branding.style.elementSpacing],
    primaryTextColor: isBrightColor(data.branding.style.primaryColor)
      ? "black"
      : "white",
  };
};
